//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {
  agreementInfo,
  agreementInfoSubmit,
  userInfo
} from './service/index'
import {
  getCookie
} from './utils/storage'
import {
  mapState,
  mapMutations
} from 'vuex'
import watermark from '@/components/watermark.vue'
import {
  setTimeout
} from 'timers';
let Base64 = require('js-base64').Base64;
const bodyScrollLock = require('body-scroll-lock');
const disableBodyScroll = bodyScrollLock.disableBodyScroll;
const enableBodyScroll = bodyScrollLock.enableBodyScroll;
const targetElement = document.querySelector("#modal");
const agreementElement = document.querySelector("#agreement-modal");
export default {
  name: 'App',
  data() {
    return {}
  },
  components: {
    watermark
  },
  watch: {
    'global.showAgreement': function (val) {
      if (val == true) {
        disableBodyScroll(agreementElement);
      } else {

      }
    }
  },
  mounted() {
    this.setTempName(Base64.decode(getCookie("user_name")))
    //this.tempName = Base64.decode(getCookie("user_name"));
  },
  computed: {
    ...mapState([
      "global", "rule", "tempName"
    ]),
  },
  methods: {
    async closeAgreement() {
      let cid = !!this.$route.query.cid ? this.$route.query.cid : -1
      const res = await agreementInfoSubmit(cid);
      enableBodyScroll(agreementElement);
      if (res.status === 0) {
        this.toggleAgreement(false)
        window.location.reload()
      }
    },
    closeAgreementDirect() {
      this.toggleAgreement(false)
    },
    closeRule() {
      enableBodyScroll(targetElement);
      this.hideRule()
    },
    ...mapMutations({
      toggleAgreement: 'TOGGLE_AGREEMENT',
      hideRule: 'HIDE_RULE',
      setTempName: 'SET_TEMPNAME'

    })
  }

}




// WEBPACK FOOTER //
// ./src/App.vue